import React, { useContext } from 'react'
import Lottie from 'react-lottie'
import { useLocation } from 'react-router-dom'

import { compose } from 'recompose'

import {
  AnalyzingContainer,
  AnimationContainer,
  CascadingText,
  DesktopFootnote,
  lottieOptions,
} from 'components/Analyzing'
import EllipsisText from 'components/EllipsisText'
import Layout from 'components/Layout'
import { MobileFootnote } from 'components/MobileFootnote'
import Nav from 'components/Nav'
import { ActionType, PageName } from 'generated/types'
import { WithFlowRouterProps, withFlowRouter } from 'utils/FlowProvider'
import { FlowRoute } from 'utils/FlowProvider/types'
import { FunnelContext } from 'utils/FunnelContext'

const VALUES = ['Income', 'Age', 'Time Horizon', 'Net Worth']

const enhance = compose<WithFlowRouterProps, {}>(withFlowRouter)

export const Analyzing = enhance(({ route }) => {
  const location = useLocation()
  const { isDynamicFunnelEnabled, routeToPage } = useContext(FunnelContext)

  const callback = () => {
    isDynamicFunnelEnabled
      ? routeToPage(PageName.SuitabilityQuestions, ActionType.Continue, location.state)
      : route({ from: FlowRoute.Analyzing, action: 'continue', locationState: location.state })
  }

  return (
    <>
      <Nav />
      <Layout>
        <AnimationContainer>
          <Lottie
            isClickToPauseDisabled={true}
            options={lottieOptions}
            eventListeners={[
              {
                eventName: 'complete',
                callback,
              },
            ]}
          />
        </AnimationContainer>
        <AnalyzingContainer>
          <EllipsisText text={'Analyzing'} dots={3} />
          <CascadingText values={VALUES} />
        </AnalyzingContainer>
        <DesktopFootnote>
          Based on your responses we are calculating a recommended portfolio for you.
        </DesktopFootnote>
      </Layout>
      <MobileFootnote>
        Based on your responses we are calculating a recommended portfolio for you.
      </MobileFootnote>
    </>
  )
})
